export default __webpack_public_path__ + "static/media/p26.eb337635.jpg";